const INFILTRATION_ORIGINAL_TOKEN_KEY = "usr_token_before_infiltration";

export function storeOriginalTokenForInfiltration() {
  const currentToken = localStorage.getItem("usr_token");

  if (!currentToken) {
    return;
  }

  localStorage.setItem(INFILTRATION_ORIGINAL_TOKEN_KEY, currentToken);
}

export function getOriginalTokenForInfiltration() {
  return localStorage.getItem(INFILTRATION_ORIGINAL_TOKEN_KEY);
}

export function clearOriginalTokenForInfiltration() {
  localStorage.removeItem(INFILTRATION_ORIGINAL_TOKEN_KEY);
}
